"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var ActionTypes_1 = require("../ActionTypes");
var initialState = {
    queue: [],
};
function default_1(state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes_1.UPDATE_BUILD_SESSION: {
            if (action.summary !== undefined) {
                return __assign(__assign({}, state), { queue: __spreadArrays([action.summary], state.queue.slice(0, 2)) });
            }
            else {
                return __assign({}, state);
            }
        }
        case ActionTypes_1.ADD_TOAST: {
            return __assign(__assign({}, state), { queue: __spreadArrays([action.summary], state.queue.slice(0, 2)) });
        }
        case ActionTypes_1.UPDATE_TOAST_QUEUE: {
            return __assign(__assign({}, state), { queue: action.data });
        }
        case ActionTypes_1.CLEAR_TOAST_QUEUE: {
            return __assign(__assign({}, state), { queue: [] });
        }
        default: {
            return state;
        }
    }
}
exports.default = default_1;
//# sourceMappingURL=ToastMessages.js.map